// aliasing the global function for improved minification and
// protection against hasOwnProperty overrides.
export function addEventListener(target, eventType, callback, capture = false) {
    if (target.addEventListener) {
        target.addEventListener(eventType, callback, capture);
    }
    else if (target.attachEvent) {
        // The legacy API has no capture phase. Listeners that ask for one still get registered,
        // they just observe the bubble phase.
        target.attachEvent("on" + eventType, callback);
    }
}
export function removeEventListener(target, eventType, callback, capture = false) {
    if (target.removeEventListener) {
        // The capture flag is part of a listener's identity: removal only works when it matches
        // the flag the listener was registered with.
        target.removeEventListener(eventType, callback, capture);
    }
    else if (target.detachEvent) {
        target.detachEvent("on" + eventType, callback);
    }
}
